import { getDomain } from '../utilities';
import { env } from '../configs';

export const getLanguage = () => {
    return window.localStorage.getItem('language') || getDomain() || env.REACT_APP_DEFAULT_LANGUAGE;
};
